import { CustomCellDate, CrudLink } from "@/shared/components";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import type { OrganizationRow } from "./types";
import type { OrganizationUsersListRow } from "@/admin/entities/organizationUsers";
import { OrganizationUserRolesCell } from "./OrganizationUserRolesCell";

/**
 * Конфигурация UI для feature управления организациями
 */

// Конфигурация колонок таблицы
export const getColumnsConfig = () => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "title",
    label: "Название",
    options: {
      customBodyRender: (data: unknown) => {
        const organization = data as OrganizationRow;
        return (
          <CrudLink id={organization.id} tab="details">
            {organization.title}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "createdAt",
    label: "Дата создания",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

// Конфигурация текстов интерфейса
export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Организации",
  itemCreated: "Организация создана",
  itemUpdated: "Организация обновлена",
  createItem: "Создать организацию",
  refetchList: "Обновить список",
  deleteItems: "Удалить организации",
  itemsDeleted: "Организации удалены",
  restoreItems: "Восстановить организации",
  itemsRestored: "Организации восстановлены",
  cancel: "Отмена",
  editItem: "Организация",
  showTitle: "Детали",
});

export const getOrganizationUsersColumnsConfig = () => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "name",
    label: "Имя",
    options: {
      customBodyRender: (data: unknown) => {
        const { user } = data as OrganizationUsersListRow;
        return (
          <CrudLink id={user.id} tab="details" path="/admin/users">
            {user.displayName}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "roles",
    label: "Роли",
    options: {
      customBodyRender: (data: unknown) => {
        const row = data as OrganizationUsersListRow;
        return <OrganizationUserRolesCell row={row} />;
      },
    },
  },
  {
    name: "createdAt",
    label: "Дата создания",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

export const getOrganizationUsersTextsConfig = () => ({
  listTitle: "Сотрудники",
  createItem: "Добавить сотрудника",
  itemCreated: "Сотрудник добавлен",
  itemsDeleted: "Сотрудники удалены",
});

// Колонки для мобильного представления: название и дата создания
export const getMobileColumnsConfig =
  (): DataListViewColumns<OrganizationRow> => ({
    main: {
      title: "Организация",
      sx: { flex: 1, minWidth: 0 },
      renderCell: (row) => (
        <CrudLink id={row.id} tab="details" noWrap>
          {row.title}
        </CrudLink>
      ),
    },
    createdAt: {
      title: "Создана",
      sx: { width: 96, flexShrink: 0 },
      renderCell: (row) => <CustomCellDate date={row.createdAt as string} />,
    },
  });
